(function () {
    'use strict';

    angular.module('app').controller('TransactionsController', TransactionsController);

    TransactionsController.$inject = [
        '$scope',
        '$rootScope',
        '$route',
        '$routeParams',
        '$timeout',
        '$filter',
        '$translate',
        'blockUI',
        '$uibModal',
        'ExportService',
        'TransactionService',
        'SelectService',
        'CustomerService',
        'CustomPreferencesService',
        'CorporateCustomerService',
        'BusinessService',
        'LoyaltyService',
        'SettingsService',
        'GoodsService',
        'ReceiptService',
        '$sce',
        'NotifyService',
        'EmbeddedService'
    ];

    function TransactionsController(
        $scope,
        $rootScope,
        $route,
        $routeParams,
        $timeout,
        $filter,
        $translate,
        blockUI,
        $uibModal,
        ExportService,
        TransactionService,
        SelectService,
        CustomerService,
        CustomPreferencesService,
        CorporateCustomerService,
        BusinessService,
        LoyaltyService,
        SettingsService,
        GoodsService,
        ReceiptService,
        $sce,
        NotifyService,
        EmbeddedService
    ) {
        var isCorporateMode = !!$route.current.$$route.isCorporateMode;
        $scope.isCorporateMode = isCorporateMode;
        var isAllMode = !!$route.current.$$route.isAllMode;
        $scope.isAllMode = isAllMode;

        var ENV_KEY_PARAMS = isCorporateMode ? 'params_corporate' : 'params';
        var customPreferencesKey = isCorporateMode ? 'TRANSACTIONS_TABLE_COLS_CORPORATE' : 'TRANSACTIONS_TABLE_COLS';

        $scope.corporate_customer_id = false;

        if ($routeParams.corporate_customer_id && isCorporateMode) {
            $scope.corporate_customer_id = $routeParams.corporate_customer_id;
            $scope.corporate_customer = {};
            CorporateCustomerService.GetCorporateCustomer($scope.corporate_customer_id, function (success, data) {
                if (success) {
                    $scope.corporate_customer = data;
                    $scope.getTransactions();
                } else {

                }
            });
        }

        CorporateCustomerService.All({
            page: 1,
            count: 1,
            suspended: 'all'
        }, function (success, data) {
            if (success && data.data.length > 0) {
                $scope.data.isSupportCorporateCustomer = true;
            }
        });

        $scope.user_id = false;
        if ($routeParams.user_id && !isCorporateMode && !isAllMode) {
            $scope.user_id = $routeParams.user_id;
            setTimeout(function () {
                $scope.getTransactions();
            }, 400);
        }
        $scope.getFiltersList = function () {
            $scope.data.filtersList = [
                {
                    loading: true,
                },
            ];
            SelectService.getLPRList();
        };

        $scope.getPages = getTotalPaginatedPages;
        $scope.getTransactions = getTransactions;
        $scope.getTransactionTypeDescription = getTransactionTypeDescription;
        $scope.billingInfo;
        $scope.isSupportUserExternalId = false;
        $scope.specialAccounts = [
            {title: $filter('translate')('All special accounts'), id: '', corporate: null}
        ];

        $scope.businessStaffs = [
            {name: $filter('translate')('Transaction business all staffs'), id: ''}
        ];

        $scope.model = {
            by_stock: false,
            extra_customer_info: false
        };

        $scope.params = {
            transactions_preset: {
                page: 1,
                count: 20,
                date_from: moment().subtract(1, 'month').utc().toDate(),
                date_to: moment().endOf('day').utc().toDate(),
                time_from: moment().startOf('day').utc().toDate(),
                time_to: moment().endOf('day').utc().toDate(),
                sort_direction: 'DESC',
                sort_field: 'processed',
                include_questionnaire: false,
                customer_type: 'all',
                payment_type: 'all',
                business_staff_id: null,
                include_taxes: false,
                include_margins: false,
                include_customer_additional_cards: false,
            }
        };

        if ($routeParams.special_account_id && isCorporateMode) {
            $scope.params.transactions_preset.special_account = $routeParams.special_account_id;
        }

        if ($routeParams.user_id && !isCorporateMode) {
            $scope.params.transactions_preset.user_id_value = $routeParams.user_id;
            $scope.params.transactions_preset.user_id_type = 'id';
        }

        $scope.data = {
            showTableDisplaySettings: false,
            isFilePreparing: false,
            transactionsList: null,
            summary: {},
            pagerLengths: [10, 20, 50, 100, 200],
            isSupportCorporateCustomer: true
        };

        $scope.data.transactionTypes = [
            {value: 'all', text: 'all transaction types', visible: true},
            {value: 'reserve', text: 'reserve transaction type', visible: true},
            {value: 'sale', text: 'sale transaction type', visible: true},
            {value: 'authorize-payment', text: 'Authorize payment', visible: true},
            {value: 'bonus-add', text: 'bonus add transaction type', visible: true},
            {value: 'bonus-write-offs', text: 'bonus-write-offs transaction type', visible: true},
            {value: 'special-account-refill', text: 'special account refill transaction type', visible: true},
            {value: 'special-account-write-offs', text: 'special-account-write-offs transaction type', visible: true},
            {value: 'coupon-sale', text: 'coupon-sale transaction type', visible: true}
        ];
        $scope.data.customerTypes = [
            {value: 'all', text: 'all customers transaction types'},
            {value: 'retail', text: 'retail customers transaction types'},
            {value: 'corporate', text: 'corporate customers transaction types'}
        ];

        $scope.data.paymentTypes = [
            {value: 'all', text: 'transaction#filter#payment_type#all'},
            {value: 'money', text: 'transaction#filter#payment_type#currency'},
            {value: 'account', text: 'transaction#filter#payment_type#special-account'},
        ];

        $scope.data.transactionStatuses = [
            {value: '', text: 'All transactions', visible: true},
            {value: 'true', text: 'canceled status false', visible: true},
            {value: 'false', text: 'canceled status true', visible: true}
        ];

        $scope.data.table_cols_preset = [
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'sequence_number', text: 'Sequence number', onlyForExport: true, visible: false},
                    {value: 'user_phone', text: 'Customer number', visible: true},
                    {value: 'user_email', text: 'Customer email', visible: true},
                    {value: 'user_name', text: 'Username', visible: true},
                    {value: 'edit_user', text: 'Edit customer', visible: true, not_sortable: true, no_export: true},
                    {value: 'receipt_link', text: 'TEXT_RECEIPT', visible: true, not_sortable: true},
                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'corporate_customer_name', text: 'Corporate user name', visible: true},
                    {value: 'corporate_customer_email', text: 'Corporate user login', visible: true},
                    {value: 'edit_corporate_customer', text: 'Edit corporate user', visible: true, not_sortable: true, no_export: true},
                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'processed', text: 'Processed', visible: true},
                    {value: 'comment', text: 'Transaction comment', visible: true},
                    {value: 'online_store_order_id', text: 'TEXT_TRANSACTION_ORDER', visible: true, not_sortable: true}
                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {
                        value: 'local_date',
                        isDate: true,
                        text: 'Local date',
                        dateFormat: 'shortDate',
                        visible: true,
                        not_sortable: true
                    },
                    {value: 'local_time', text: 'Local time', visible: true, not_sortable: true}
                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'pos_title', text: 'POS name', visible: true},
                    {value: 'terminal_title', text: ' Platform Register name', visible: true},
                    {value: 'terminal_phone', text: 'Register phone number', visible: true},
                    {value: 'terminal_external_id', text: 'Terminal internal ID', visible: false, onlyForExport: true},
                    {value: 'internalIdOrCard', text: 'Internal Id Or Card', visible: false, onlyForExport: true}
                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'type', text: 'Transaction type', visible: true},
                    {value: 'payment_type', text: 'Payment type', visible: true}
                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'special_account_title', text: 'Name special account', visible: true},
                    {value: 'special_account_amount', text: 'Remaining special account', visible: true}
                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'amount', text: 'Amount without delivery', visible: false},
                    {value: 'discount_amount', text: 'Discount amount', visible: true},
                    {value: 'services_amount', text: 'Services amount', visible: true},
                    {value: 'shipping_amount', text: 'TEXT_DELIVERY_COST', visible: false},
                    {value: 'summary_amount', text: 'Amount with shipping costs', visible: true},
                    {value: 'amount_to_pay', text: 'Payment amount', visible: true}
                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'bonuses_added', text: 'Bonuses earned', visible: true},
                    {value: 'bonuses_redeemed', text: 'Bonuses redeemed', visible: true},
                    {value: 'bonuses_on_account', text: 'Bonuses on hand', visible: true}
                ]
            },
            {
                visible: true,
                enabled: false,
                data: [
                    {value: 'sc_code', text: 'Temporary code', visible: true},
                    {value: 'sc_bonuses_redeem', text: 'Redeemable without PIN confirmation', visible: true},
                    {value: 'sc_terminal_phone', text: 'Originating Register phone number', visible: true},
                    {value: 'sc_terminal_title', text: 'Originating Register Title', visible: true}
                ]
            },
            {
                visible: false,
                enabled: true,
                data: [
                    {value: 'vehicle_id', text: 'Vehicle id', visible: false},
                    {value: 'odometer', text: 'Odometer', visible: false},
                    {value: 'corporate_vehicle_qr_code', text: 'corporate_vehicle_qr_code', visible: false},
                    {value: 'corporate_vehicle_description', text: 'Vehicle description', visible: false},
                    {value: 'corporate_position_title', text: 'Staff position', visible: false}
                ]
            },
            {
                visible: false,
                enabled: true,
                data: [
                    {value: 'business_staff_name', text: 'Business staff name', visible: false, not_sortable: true},
                ]
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {value: 'cancelled', text: 'Status', visible: true},
                    {value: 'actions', text: 'Actions', visible: true, not_sortable: true, no_export: true}
                ]
            }
        ];
        $scope.data.table_cols_preset = CustomPreferencesService.addBlankColumns($scope.data.table_cols_preset);
        $scope.dateFormats = CustomPreferencesService.dateFormats;
        $scope.data.exportHeaders = true;

        var block_transactions_list = blockUI.instances.get('transactions_list');
        var block_transactions_page = blockUI.instances.get('transactions_page');

        SettingsService.GetPlatformParams(function (success, response) {

            if (success) {
                $scope.isSupportUserExternalId = !!response.support_external_id_primary_identifier;

                if ($scope.isSupportUserExternalId) {
                    $scope.data.table_cols_preset[0].data.splice(($scope.data.table_cols_preset[0].data.length - 3), 0, {
                        value: 'user_external_id',
                        text: 'Customer external id',
                        visible: true,
                        not_sortable: true
                    });
                }
            }
            initController();
        });

        function getLegalInfo() {
            BusinessService.LegalInfo(function (success, data) {
                if (success) {
                    $scope.legal_info = data;

                    $scope.legal_info.customer_representative = '';

                    if ($rootScope.USER.name)
                        $scope.legal_info.user_name = $rootScope.USER.name;
                    if ($rootScope.USER.phone)
                        $scope.legal_info.user_phone = $rootScope.USER.phone;
                    if ($rootScope.USER.login)
                        $scope.legal_info.user_email = $rootScope.USER.login;

                    $scope.legal_info.account_owner_details = '';
                    if ($rootScope.USER.name)
                        $scope.legal_info.account_owner_details += $rootScope.USER.name + '\n';
                    if ($rootScope.USER.phone)
                        $scope.legal_info.account_owner_details += $rootScope.USER.phone + ', ';
                    if ($rootScope.USER.login)
                        $scope.legal_info.account_owner_details += $rootScope.USER.login;
                }
            });
        }

        function initTransactionsFiters() {
            $scope.params.transactions = angular.copy($scope.params.transactions_preset);
        }

        function initTableColumns(isReset) {
            return new Promise(function (resolve) {
                if ($rootScope.ENV.business.status.show_sc_in_transations_list === 1)
                    for (var i in $scope.data.table_cols)
                        $scope.data.table_cols[i].enabled = true;
                if (!isReset) {
                    block_transactions_page.start();
                    CustomPreferencesService.initTableColumns(
                        customPreferencesKey,
                        $scope.data.table_cols_preset,
                        $scope.data.exportHeaders
                    ).then(function (preferences) {
                        $scope.data.table_cols = preferences.tableColumns;
                        $scope.data.exportHeaders = preferences.exportHeaders;
                        block_transactions_page.stop();
                        enableCols();
                        resolve();
                    });
                } else {
                    $scope.data.table_cols = angular.copy($scope.data.table_cols_preset);
                    enableCols();
                    resolve();
                }
            });
        }

        function enableCols() {
            if ($rootScope.ENV.business.status.show_sc_in_transations_list === 1)
                for (var i in $scope.data.table_cols)
                    $scope.data.table_cols[i].enabled = true;
        }

        function initController() {
            initTransactionsFiters();
            getSpecialAccounts();
            getBusinessStaffs();
            getLegalInfo();

            $scope.business = angular.copy($rootScope.ENV.business);
        }

        function _doShow(reloadTransactions) {
            if (reloadTransactions === true) {
                getTransactions();
            }

            function s() {
                if ($rootScope.ENV.business.tariff) {
                    if ($rootScope.ENV.business.tariff.export_transactions_list)
                        $rootScope.TARIFF_LIMITATION.export_transactions_list = false;
                    else
                        $rootScope.TARIFF_LIMITATION.export_transactions_list = true;
                } else {
                    $timeout(s, 250);
                }
            }

            s();

            $scope.getListOfGoods(function (success) {
                if (success) {
                    $scope.params.transactions.items = _makeDictTag($scope.params.transactions.items, true);
                }
            });
        }

        function _makeDictTag(goodsList, showTitle) {
            var result = [];

            if (goodsList) {
                if (showTitle) {
                    goodsList.forEach(function (goodItem) {
                        var searchedItem = $scope.model.goodsList.find(function (item) {
                            if (item.title === goodItem || item.code === goodItem) {
                                return true;
                            }
                        });

                        if (searchedItem) {
                            result.push({
                                title: searchedItem.title,
                                isTag: true,
                                code: searchedItem.code
                            });
                        } else {
                            result.push({
                                title: goodItem,
                                isTag: true,
                                code: goodItem
                            });
                        }

                    });
                } else {
                    goodsList.forEach(function (goodItem) {
                        var searchedItemForFalse = $scope.model.goodsList.find(function (item) {
                            if (item.title === goodItem) {
                                return true;
                            }
                        });

                        if (searchedItemForFalse) {
                            result.push(searchedItemForFalse);
                        } else {
                            result.push({code: goodItem});
                        }

                    });
                }
            }
            return result;
        }

        /**
         * Поля с информацией о корпоративном покупателе и транспорте получаем только если эти поля отображаюся в таблице,
         * так как получение этой информации из бд занимает много времени
         */
        function includeVehicleInfo(transactionsParams) {
            var params = angular.copy(transactionsParams);
            $scope.data.table_cols.forEach(function (col) {
                col.data.forEach(function (data) {
                    if (data.value === 'odometer') {
                        params.include_odometer = data.visible;
                    } else if (data.value === 'vehicle_id') {
                        params.include_vehicle_id = data.visible;
                    } else if (data.value === 'corporate_position_title') {
                        params.include_corporate_staff = data.visible;
                    } else if (data.value === 'corporate_vehicle_qr_code' || data.value === 'corporate_vehicle_description') {
                        params.include_corporate_vehicle = data.visible;
                    }
                });
            });
            return params;
        }

        function getTransactions() {
            block_transactions_list.start();
            $scope.data.transactionsList = null;
            $scope.data.summary = {};

            initTableColumns().then(function () {
                var params = angular.copy($scope.params.transactions);

                params.sort = '{0} {1}'.format(params.sort_field, params.sort_direction);
                delete params.sort_direction;
                delete params.sort_field;

                params.date_from = moment(params.date_from).set({
                    hour: moment(params.time_from).get('hour'),
                    minute: moment(params.time_from).get('minute'),
                    second: moment(params.time_from).get('second')
                });
                delete params.time_from;

                params.date_to = moment(params.date_to).set({
                    hour: moment(params.time_to).get('hour'),
                    minute: moment(params.time_to).get('minute'),
                    second: moment(params.time_to).get('second')
                });
                delete params.time_to;

                if ($scope.data.currentFilter && $scope.data.currentFilter.id !== '0') {
                    var cf = $scope.data.currentFilter;
                    switch (cf.filter_list_type) {
                        case 'loyalty':
                            params.loyalty = cf.id;
                            break;
                        case 'pos':
                            params.pos = cf.id;
                            break;
                        case 'register':
                            params.terminal = cf.id;
                            break;
                    }
                }

                params = dateFieldsFormat(params, null, 'YYYY-MM-DD[T]HH:mm:ss[Z]', false);
                params = cleanRequestData(params);
                if (isCorporateMode) {
                    params.customer_type = 'corporate';
                }

                if ($routeParams.corporate_customer_id && isCorporateMode) {
                    params.corporate_customer_id = $routeParams.corporate_customer_id;
                }

                if ($routeParams.user_id && !isCorporateMode) {
                    params.user_id_type = 'id';
                    params.user_id_value = $routeParams.user_id;
                }

                if (!$routeParams.user_id) {
                    delete params.user_id_type;
                    delete params.user_id_value;
                }

                params = includeVehicleInfo(params);

                if (params.include_taxes) {
                    $scope.data.table_cols.splice($scope.data.table_cols.length - 1, 0, {
                        visible: true,
                        enabled: true,
                        no_export: true,
                        data: [
                            {
                                value: 'include_taxes',
                                text: 'taxes',
                                visible: true,
                            }
                        ]
                    })
                }

                if (params.include_margins) {
                    $scope.data.table_cols.splice($scope.data.table_cols.length - 1, 0, {
                        visible: true,
                        enabled: true,
                        no_export: true,
                        data: [
                            {
                                value: 'include_margins',
                                text: 'margins',
                                visible: true,
                            }
                        ]
                    })
                }

                if (params.include_customer_additional_cards) {
                    $scope.data.table_cols.splice($scope.data.table_cols.length - 1, 0, {
                        visible: true,
                        enabled: true,
                        no_export: true,
                        data: [
                            {
                                value: 'customer_additional_cards',
                                text: 'Additional cards',
                                visible: true,
                                not_sortable: true
                            }
                        ]
                    })
                }

                TransactionService.All(params, function (success, response) {
                    if (success) {
                        if (params.include_questionnaire) {
                            if (isAllMode) {
                                CustomerService.CustomerFields(function (success, user_data) {
                                    var customUserFields = [];
                                    for (var fieldIndex in user_data) {
                                        customUserFields.push({
                                            value: user_data[fieldIndex].value_field_name,
                                            text: user_data[fieldIndex].description + ` [${++fieldIndex}](retail)`,
                                            visible: true
                                        });
                                    }
                                    $scope.data.table_cols.splice(1, 0, {
                                        visible: true,
                                        enabled: true,
                                        customUserFields: true,
                                        data: customUserFields
                                    })

                                    CorporateCustomerService.CorporateFields(function (success, corporate_data) {
                                        var customCorporateFields = [];
                                        for (var fieldIndex in corporate_data) {
                                            var text = corporate_data[fieldIndex].title;
                                            console.log(text)
                                            if (corporate_data[fieldIndex].type == "dictionary") {
                                                text = corporate_data[fieldIndex].public_title[$rootScope.LANG] || corporate_data[fieldIndex].title;
                                            }
                                            customCorporateFields.push({
                                                value: corporate_data[fieldIndex].value_field_name,
                                                text: text + ` [${++fieldIndex}](corporate)`,
                                                visible: true
                                            });
                                        }
                                        $scope.data.table_cols.splice(1, 0, {
                                            visible: true,
                                            enabled: true,
                                            customCorporateFields: true,
                                            data: customCorporateFields
                                        })
                                    })
                                });
                            } else {
                                if (isCorporateMode) {
                                    CorporateCustomerService.CorporateFields(function (success, data) {
                                        var customFields = [];
                                        for (var fieldIndex in data) {
                                            var text = data[fieldIndex].title;
                                            console.log(text)
                                            if (data[fieldIndex].type == "dictionary") {
                                                text = data[fieldIndex].public_title[$rootScope.LANG] || data[fieldIndex].title;
                                            }
                                            customFields.push({
                                                value: data[fieldIndex].value_field_name,
                                                text: text + ` [${++fieldIndex}](corporate)`,
                                                visible: true
                                            });
                                        }
                                        $scope.data.table_cols.splice(1, 0, {
                                            visible: true,
                                            enabled: true,
                                            customCorporateFields: true,
                                            data: customFields
                                        })
                                    })
                                }
                            }
                        }

                        $scope.data.transactionsList = response.data;
                        $scope.data.summary = response.summary;
                        if (!$scope.corporate_customer_id) {
                            $rootScope.ENV.filters.transactions_list[ENV_KEY_PARAMS] = JSON.stringify($scope.params.transactions);
                        }

                        $rootScope.storeENV();

                        updateTransactionsSummary().then();

                    }

                    $timeout(function () {
                        block_transactions_list.stop();
                    }, 1000);

                });
            });
        }

        function updateTransactionsSummary() {
            return new Promise(function (resolve) {
                $scope.data.summary_cols = [];
                for (var i in $scope.data.table_cols) {
                    if ($scope.data.table_cols[i].enabled)
                        if (i === 0)
                            $scope.data.summary_cols.push({
                                visible: $scope.data.table_cols[i].visible,
                                data: [$filter('translate')('Total values')]
                            });
                        else
                            $scope.data.summary_cols.push({visible: $scope.data.table_cols[i].visible, data: []});

                    for (var k in $scope.data.table_cols[i].data) {
                        if ($scope.data.table_cols[i].data[k].visible) {
                            if ($scope.data.summary_cols[i])
                                switch ($scope.data.table_cols[i].data[k].value) {
                                    case 'amount':
                                        $scope.data.summary_cols[i].data.push($scope.data.summary.total_amount);
                                        break;
                                    case 'shipping_amount':
                                        $scope.data.summary.total_shipping_amount;
                                        break;
                                    case 'summary_amount':
                                        $scope.data.summary_cols[i].data.push($scope.data.summary.total_summary_amount);
                                        break;
                                    case 'bonuses_added':
                                        $scope.data.summary_cols[i].data.push($scope.data.summary.total_bonuses_added);
                                        break;
                                    case 'bonuses_redeemed':
                                        $scope.data.summary_cols[i].data.push($scope.data.summary.total_bonuses_redeemed);
                                        break;
                                    case 'discount_amount':
                                        $scope.data.summary_cols[i].data.push($scope.data.summary.total_discount_amount);
                                        break;
                                    case 'amount_to_pay':
                                        $scope.data.summary_cols[i].data.push($scope.data.summary.total_amount_to_pay);
                                        break;
                                }
                        }
                    }
                }
                resolve();
            });

        }

        $scope.SpecialAccountsGroupFn = function (specialAccount) {

            if (specialAccount.corporate === null) {
                return '';
            }
            if (!!specialAccount.corporate) {
                return $filter('translate')('Corporate accounts') || 'Corporate accounts';
            }
            return $filter('translate')('Customer accounts') || 'Customer accounts';
        };

        function getSpecialAccounts() {
            $scope.specialAccounts = [];
            EmbeddedService.GetSpecialAccounts({'scope': isCorporateMode ? 'corporate' : 'all'}, function (success, response) {
                if (success && response) {
                    $scope.specialAccounts = [
                        {title: $filter('translate')('All special accounts'), id: '', corporate: null}
                    ].concat(response);

                }
            });
        }

        function getBusinessStaffs() {
            $scope.businessStaffs = [];
            EmbeddedService.GetStaff({}, function (success, response) {
                if (success && response) {
                    $scope.businessStaffs = [
                        {name: $filter('translate')('Transaction business all staffs'), id: ''}
                    ].concat(response);
                }
            });
        }

        $scope.onDownloadPDF = function (data, isCopyCustomer) {
            TransactionService.GetTransactionReceipt(data.id, function (success, data) {
                if (success) {
                    ReceiptService.getPdf(data, isCopyCustomer, function (successPdf, res) {
                        if (!successPdf) {
                            NotifyService.Error('Can not print the receipt', true);
                            return;
                        }
                        var binary = atob(res.data.data.replace(/\s/g, ''));
                        var len = binary.length;
                        var buffer = new ArrayBuffer(len);
                        var view = new Uint8Array(buffer);
                        for (var i = 0; i < len; i++) {
                            view[i] = binary.charCodeAt(i);
                        }
                        var blob = new Blob([view], {type: "application/pdf"});
                        saveAs(blob, `receipt-${data.id}.pdf`);
                    })
                } else {
                    NotifyService.Error('Can not print the receipt', true);
                }
            })
        };

        function popupTransactionCheck(check, transaction) {
            $scope.operationResult = $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/templates/modal.receipt.html',
                controllerAs: 'popup',
                windowClass: "receipt-modal",
                controller: function ($uibModalInstance) {

                    var popup = this;

                    var receipt_block = blockUI.instances.get('receipt_block');
                    popup.model = {};
                    receipt_block.start();

                    TransactionService.GetTransactionReceipt(transaction.id, function (success, data) {
                        if (success) {
                            popup.model.receipt = data;
                            ReceiptService.getView(data, function (success, viewData) {
                                popup.model.receiptView = $sce.trustAsHtml(viewData.data);
                                receipt_block.stop();
                            })
                        } else {
                            receipt_block.stop();
                        }
                    })

                    popup.onDownloadPDF = function (isCopyCustomer) {
                        ReceiptService.getPdf(popup.model.receipt, isCopyCustomer, function (success, res) {
                            if (!success) {
                                NotifyService.Error('Can not print the receipt', true);
                                return;
                            }
                            var binary = atob(res.data.data.replace(/\s/g, ''));
                            var len = binary.length;
                            var buffer = new ArrayBuffer(len);
                            var view = new Uint8Array(buffer);
                            for (var i = 0; i < len; i++) {
                                view[i] = binary.charCodeAt(i);
                            }
                            var blob = new Blob([view], {type: "application/pdf"});
                            saveAs(blob, `receipt-${popup.model.receipt.id}.pdf`);
                        })
                    };


                    popup.onCheckPrint = function () {
                        ReceiptService.getPdf(popup.model.receipt, false, function (success, res) {
                            if (!success) {
                                NotifyService.Error('Can not print the receipt', true);
                                return;
                            }
                            var binary = atob(res.data.data.replace(/\s/g, ''));
                            var len = binary.length;
                            var buffer = new ArrayBuffer(len);
                            var view = new Uint8Array(buffer);
                            for (var i = 0; i < len; i++) {
                                view[i] = binary.charCodeAt(i);
                            }
                            var blob = new Blob([view], {type: "application/pdf"});
                            var url = URL.createObjectURL(blob);

                            var myWindow = window.open(url, '_blank');
                            myWindow.print();
                            myWindow.focus();
                        })
                    };

                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    };

                    popup.onRawClick = function () {
                        $scope.operationResult = $uibModal.open({
                            animation: true,
                            keyboard: true,
                            size: 'lg',
                            templateUrl: 'app/templates/modal.raw.html',
                            controllerAs: 'popup',
                            controller: function ($uibModalInstance) {

                                var popup = this;

                                popup.model = {
                                    raw: check
                                };

                                popup.onCancelClick = function () {
                                    $uibModalInstance.close();
                                };

                            }
                        });
                    };
                }
            });
        }

        $scope.onGetCheck = function (transaction) {
            TransactionService.GetTransactionCheck(transaction.id, function (success, response) {
                if (success) {
                    popupTransactionCheck(response, transaction);
                }
            });
        };

        $scope.getListOfGoods = function (callback) {
            $scope.model.goodsList = [];

            function handleResult(success, result) {
                if (success) {
                    $scope.model.goodsList = $scope.model.goodsList.concat(result);
                    callback(true);
                }
            }

            var loyaltyId,
                terminalId;

            if ($scope.data.currentFilter && $scope.data.currentFilter.id !== '0') {
                var cf = $scope.data.currentFilter;
                console.log('CF =>', cf);
                switch (cf.filter_list_type) {
                    case 'loyalty':
                        loyaltyId = cf.id;
                        break;
                    case 'pos':
                        loyaltyId = cf.loyalty_id;
                        break;
                    case 'register':
                        loyaltyId = cf.loyalty_id;
                        break;
                }

                var params = { service_type: 'all' };

                if (loyaltyId) {
                    params.loyalty_id = loyaltyId;
                }

                if (terminalId) {
                    params.terminal_id = terminalId;
                }

                EmbeddedService.GetGoods(params, handleResult);

            } else {
                EmbeddedService.GetGoods({ service_type: 'all' }, handleResult);
            }
        };

        function popupTransactionOrder(order, transaction) {
            $scope.operationResult = $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/templates/modal.order.details.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    console.log('This order =>', popup);

                    popup.model = {
                        order: order
                    };

                    popup.model.loyalty = {
                        id: transaction.loyalty_id,
                        title: transaction.loyalty_title
                    };

                    if (popup.model.order.loyalty_id) {
                        LoyaltyService.LoyaltyOnlineStore(popup.model.order.loyalty_id, function (success, response) {
                            if (success) {
                                popup.model.onlinestore = response;
                            }
                        });
                    }

                    if (popup.model.order.shipping) {
                        popup.model.order_shipping = {
                            delivery_title: null,
                            delivery_date: null,
                            delivery_time: null,
                            ship_to_address: null,
                            ship_to_phone: null,
                            ship_to_name: null
                        };

                        if (popup.model.order.shipping.delivery_date) {
                            popup.model.order_shipping.delivery_date = popup.model.order.shipping.delivery_date;
                        }
                        if (popup.model.order.shipping.delivery_time) {
                            popup.model.order_shipping.delivery_time = popup.model.order.shipping.delivery_time;
                        }

                        if (popup.model.order.shipping.delivery && popup.model.order.shipping.delivery.title) {
                            popup.model.order_shipping.delivery_title = popup.model.order.shipping.delivery.title;
                        }

                        if (popup.model.order.shipping.ship_to) {
                            if (popup.model.order.shipping.ship_to.address) {
                                popup.model.order_shipping.ship_to_address = popup.model.order.shipping.ship_to.address;
                            }
                            if (popup.model.order.shipping.ship_to.phone) {
                                popup.model.order_shipping.ship_to_phone = popup.model.order.shipping.ship_to.phone;
                            }
                            if (popup.model.order.shipping.ship_to.first_name) {
                                popup.model.order_shipping.ship_to_name = popup.model.order.shipping.ship_to.first_name;
                                if (popup.model.order.shipping.ship_to.last_name) {
                                    popup.model.order_shipping.ship_to_name += ' ';
                                    popup.model.order_shipping.ship_to_name += popup.model.order.shipping.ship_to.last_name;
                                }
                            }
                        }
                    }

                    popup.model.active_transaction = null;
                    if (popup.model.order.transaction && popup.model.order.transaction.length > 0) {
                        for (var i in popup.model.order.transaction) {
                            if (popup.model.order.transaction[i].canceled === false) {
                                popup.model.active_transaction = popup.model.order.transaction[i];
                                break;
                            }
                        }
                    }
                    if (popup.model.active_transaction) {
                        if (popup.model.active_transaction.payments) {
                            if (popup.model.active_transaction.payments) {
                                if (popup.model.active_transaction.payments.length == 1) {
                                    switch (popup.model.active_transaction.payments[0].type) {
                                        case 'cash':
                                            popup.model.payment = {
                                                payment_type: 'cash',
                                                paid_by_cash: popup.model.active_transaction.payments[0].amount,
                                                paid_time: popup.model.active_transaction.processed
                                            };
                                            break;
                                        case 'bank-card':
                                            popup.model.payment = {
                                                payment_type: 'card',
                                                paid_by_card: popup.model.active_transaction.payments[0].amount,
                                                paid_time: popup.model.active_transaction.processed
                                            };
                                            break;
                                        case 'mobile-app':
                                            popup.model.payment = {
                                                payment_type: 'mobile',
                                                paid_by_mobile: popup.model.active_transaction.payments[0].amount,
                                                paid_time: popup.model.active_transaction.processed
                                            };
                                            break;
                                    }
                                } else if (popup.model.active_transaction.payments.length == 2) {
                                    popup.model.payment = {
                                        payment_type: 'mixed',
                                        paid_time: popup.model.active_transaction.processed
                                    };
                                    for (var i in popup.model.active_transaction.payments) {
                                        if (popup.model.active_transaction.payments[i].type === 'cash') {
                                            popup.model.payment.paid_by_cash = popup.model.active_transaction.payments[i].amount;
                                        } else if (popup.model.active_transaction.payments[i].type === 'bank-card') {
                                            popup.model.payment.paid_by_card = popup.model.active_transaction.payments[i].amount;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if (popup.model.order.user_id) {
                        CustomerService.BusinessCustomer(popup.model.order.user_id, popup.model.order.loyalty_id, function (success, response) {
                            if (success) {
                                popup.model.clientinfo = response;
                            }
                        });
                    }

                    popup.getAccountTitle = function (account_id) {
                        if ($rootScope.ACCOUNTS) {
                            return itemByIndex($rootScope.ACCOUNTS, account_id).public_title;
                        }
                    };

                    popup.onOrderPrint = function () {
                        var printContents = document.getElementById('printable-order').innerHTML;
                        var popupWin = window.open('', '_blank',
                            'screenX=1,screenY=1,left=1,top=1,' + 'width=' + screen.availWidth + ',height=' + screen.availHeight);
                        popupWin.document.open();
                        popupWin.document.write(
                            '<html><head><base href="/"><title></title><link href="assets/print/print.min.css" rel="stylesheet"/></head><body>' +
                            printContents + '</body></html>');
                        popupWin.focus();
                        var count = popupWin.document.querySelectorAll('img, link').length;
                        popupWin.document.querySelectorAll('img, link').forEach(function (el) {
                            el.onload = function () {
                                if (!--count) {
                                    setTimeout(function () {
                                        popupWin.document.execCommand('print');
                                        popupWin.document.close();
                                        popupWin.close();
                                    }, 200);
                                }
                            };
                        });
                    };

                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    };
                }
            });
        }

        $scope.onGetOrder = function (transaction) {
            TransactionService.GetTransactionOrder(transaction.id, function (success, response) {
                if (success) {
                    popupTransactionOrder(response, transaction);
                }
            });
        };

        $scope.transactionsTagHandler = function (code) {
            return {title: '', code: code};
        };

        function getTransactionTypeDescription(transaction_type) {
            var res;
            switch (transaction_type) {
                case 'bonus-add':
                    res = 'Bonus points credited to customer';
                    break;
                case 'special-account-refill':
                    res = 'Customer account replenished';
                    break;
                case 'sale':
                    res = 'Sale transaction';
                    break;
                case 'reserve':
                    res = 'Charges reserved for future transaction';
                    break;
                case 'cancel':
                    res = 'Operation cancelled';
                    break;
                case 'redeem-giftcard':
                    res = 'Gift Certificate used';
                    break;
                case 'coupon-sale':
                    res = 'Coupon sale';
                    break;
                case 'authorize-payment':
                    res = 'Authorize payment';
                    break;
                case 'presale':
                    res = 'Presale transaction';
                    break;
                case 'bonus-write-offs':
                    res = 'Bonuses written off to the buyer';
                    break;
                case 'special-account-write-offs':
                    res = 'Buyer debited from special account';
                    break;
                default:
                    res = '';
            }
            return res;
        }

        $scope.onTransactionsExport = function (format) {


            var isExportStopped = false;
            // TODO вынести создание модального окна в exportService
            $scope.modalExport = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.export.html',
                controllerAs: 'exportModal',
                controller: function ($uibModalInstance) {
                    $scope.exportModal = this;

                    // Прогресс загрузки в процентах
                    $scope.exportModal.exportProgress = 0.1;

                    // Количество загруженных записей
                    $scope.exportModal.downloadedDataCount = 0;

                    // Все количество загружаемых записей
                    $scope.exportModal.allDataCount = 0;

                    // Признак - находится ли экспорт на паузе
                    $scope.exportModal.isExportPaused = false;

                    $scope.exportModal.onTogglePause = function () {
                        $scope.exportModal.isExportPaused = !$scope.exportModal.isExportPaused;
                        if (!$scope.exportModal.isExportPaused) {
                            exportRequest();
                        }
                    };

                    $scope.exportModal.onStop = function () {
                        isExportStopped = true;
                        $scope.modalExport.close();
                        if ($scope.exportModal.isExportPaused) {
                            handleExportResults();
                        }
                    };

                    $scope.exportModal.onExit = function () {
                        $scope.exportModal.isExportPaused = true;
                        block_transactions_list.stop();
                        $scope.data.isFilePreparing = false;
                        $uibModalInstance.close();
                    };
                }
            });

            $scope.data.isFilePreparing = true;
            block_transactions_list.start();

            var params = angular.copy($scope.params.transactions);

            params.sort = '{0} {1}'.format(params.sort_field, params.sort_direction);
            delete params.sort_direction;
            delete params.sort_field;

            if ($scope.model.by_stock) {
                params.by_stock = true;
            }

            params.date_from = moment(params.date_from).set({
                hour: moment(params.time_from).get('hour'),
                minute: moment(params.time_from).get('minute'),
                second: moment(params.time_from).get('second')
            });
            delete params.time_from;

            params.date_to = moment(params.date_to).set({
                hour: moment(params.time_to).get('hour'),
                minute: moment(params.time_to).get('minute'),
                second: moment(params.time_to).get('second')
            });
            delete params.time_to;

            if ($scope.data.currentFilter && $scope.data.currentFilter.id !== '0') {
                var cf = $scope.data.currentFilter;
                switch (cf.filter_list_type) {
                    case 'loyalty':
                        params.loyalty = cf.id;
                        break;
                    case 'pos':
                        params.pos = cf.id;
                        break;
                    case 'register':
                        params.terminal = cf.id;
                        break;
                }
            }

            if (isCorporateMode) {
                params.customer_type = 'corporate';
            }

            params = dateFieldsFormat(params, null, 'YYYY-MM-DD[T]HH:mm:ss[Z]', false);
            params = cleanRequestData(params);

            params.count = $scope.data.summary.total_rows_count + 1;
            params.skip_totals = true;

            params = includeVehicleInfo(params);

            var trans = [];
            var export_struct = ExportService.getTableForExcel(format, angular.copy($scope.data.table_cols));

            function generateFile() {
                var file_name = $rootScope.ENV.business.code + '_transactions_' +
                    moment($scope.params.transactions.date_from).format('YYYY-MM-DD_HH:mm:ss') + '_' +
                    moment($scope.params.transactions.date_to).format('YYYY-MM-DD_HH:mm:ss');

                function create_export_struct() {
                    return new Promise(function (resolve) {
                        if ($scope.model.by_stock) {
                            var by_stock_fields = [
                                {text: 'Product title', value: 'item_title'},
                                {text: 'Category', value: 'item_category'},
                                {text: 'Price', value: 'item_price'},
                                {text: 'Quantity', value: 'item_quantity'},
                                {text: 'Amount', value: 'item_amount'},
                                {text: 'Discount amount', value: 'item_discount_amount'}
                            ];
                            for (var k in by_stock_fields) {
                                var text = by_stock_fields[k].text,
                                    value = by_stock_fields[k].value;

                                export_struct.push({
                                    text: $filter('translate')(text) || text,
                                    value: value
                                });
                            }
                            // export_struct = export_struct.concat(by_stock_fields);
                        }

                        var loyalty_id = null;
                        if ($scope.data.currentFilter && $scope.data.currentFilter.id !== '0') {
                            var cf = $scope.data.currentFilter;
                            switch (cf.filter_list_type) {
                                case 'loyalty':
                                    loyalty_id = cf.id;
                                    break;
                                case 'pos':
                                    loyalty_id = cf.loyalty_id;
                                    break;
                                case 'register':
                                    loyalty_id = cf.loyalty_id;
                                    break;
                            }
                        }

                        if ($scope.params.transactions.include_customer_additional_cards) {
                            export_struct.push({
                                text: $filter('translate')('Additional cards') || 'Additional cards',
                                value: 'customer_additional_cards'
                            });
                        }

                        handleTaxes();


                        function handleTaxes() {
                            if (!$scope.params.transactions.include_taxes) {
                                handleMargins();
                                return;
                            }
                            if ($scope.params.transactions.include_taxes) {
                                EmbeddedService.GetTaxes({
                                    loyalty_id: loyalty_id || null,
                                }, function (success, response) {
                                    if (success) {
                                        if (response.length > 0) {
                                            response.forEach(function (item) {
                                                export_struct.push({
                                                    text: item.title + ' (' + item.code + ')',
                                                    value: 'taxes_' + item.id
                                                });
                                            })
                                        }
                                    }
                                    handleMargins();
                                })
                            }
                        }


                        function handleMargins() {
                            if (!$scope.params.transactions.include_margins) {
                                handleQuestionnaire();
                                return;
                            }

                            EmbeddedService.GetAdditionalCosts({
                                loyalty_id: loyalty_id || null,
                            }, function (success, response) {
                                if (success) {
                                    if (response.length > 0) {
                                        response.forEach(function (item) {
                                            export_struct.push({
                                                text: item.title + ' (' + item.code + ')',
                                                value: 'margins_' + item.id
                                            });
                                        })
                                    }
                                }
                                handleQuestionnaire();
                            })
                        }


                        function handleQuestionnaire() {

                            if (!$scope.params.transactions.include_questionnaire) {
                                resolve(export_struct);
                                return;
                            }

                            if (!isCorporateMode) {
                                resolve(export_struct);
                            } else {
                                CorporateCustomerService.CorporateFields(function (success, data) {
                                    for (var fieldIndex in data) {
                                        var text = data[fieldIndex].title;
                                        if (data[fieldIndex].type == "dictionary") {
                                            text = data[fieldIndex].public_title[$rootScope.LANG] || data[fieldIndex].title;
                                        }
                                        export_struct.push({
                                            text: text,
                                            value: 'qf_' + data[fieldIndex].id.replace(/[-]*/g, '') + '_value'
                                        });
                                    }
                                    resolve(export_struct);
                                })
                            }
                        }


                    });
                }

                create_export_struct().then(function (export_struct) {
                    export_struct.push({
                        dateFormat: undefined,
                        text: $filter('translate')('TEXT_LOYALTY_REFERRAL_PROGRAM_SELECT_CURRENCY'),
                        value: 'currency'
                    });
                    var export_data = [];
                    if (trans.length > 0) {
                        for (var transIndex in trans) {
                            var el = {};
                            for (var fieldIndex in export_struct) {
                                var fieldName, fieldValue;
                                fieldName = export_struct[fieldIndex].text;

                                switch (export_struct[fieldIndex].value) {
                                    case 'sequence_number':
                                        fieldValue = Number(transIndex) + 1;
                                        break;
                                    case 'type':
                                        fieldValue = $filter('translate')(
                                            $scope.getTransactionTypeDescription(trans[transIndex][export_struct[fieldIndex].value]));
                                        break;
                                    case 'payment_type':
                                        fieldValue = $filter('translate')(trans[transIndex][export_struct[fieldIndex].value]);
                                        break;
                                    case 'cancelled':
                                        fieldValue = (trans[transIndex][export_struct[fieldIndex].value] === 1)
                                            ? $filter('translate')('Operation is cancelled')
                                            : 'OK';
                                        break;
                                    case 'local_date':
                                        fieldValue = $filter('date')(trans[transIndex]['processed_local'], export_struct[fieldIndex].dateFormat, '+0');
                                        break;
                                    case 'local_time' :
                                        fieldValue = $filter('date')(trans[transIndex]['processed_local'], 'mediumTime', '+0');
                                        break;
                                    case 'receipt_link' :
                                        fieldValue = trans[transIndex]['id'];
                                        break;
                                    case 'special_account_amount':
                                        fieldValue = trans[transIndex][export_struct[fieldIndex].value];
                                        break;
                                    case 'amount':
                                    case 'shipping_amount':
                                    case 'summary_amount':
                                    case 'services_amount':
                                    case 'amount_to_pay':
                                    case 'discount_amount':
                                        fieldValue = trans[transIndex][export_struct[fieldIndex].value];
                                        break;
                                    case 'bonuses_added':
                                    case 'bonuses_redeemed':
                                    case 'bonuses_on_account':
                                        fieldValue = trans[transIndex][export_struct[fieldIndex].value];
                                        break;
                                    case 'customer_additional_cards':
                                        fieldValue = '';
                                        if (trans[transIndex]['customer_additional_cards']) {
                                            fieldValue = trans[transIndex]['customer_additional_cards'].join(', ');
                                        }
                                        break;
                                    case 'currency' :
                                        fieldValue = trans[transIndex][export_struct[fieldIndex].value];
                                        break;
                                    case 'internalIdOrCard':
                                        fieldValue = '';
                                        if (trans[transIndex]['type'] && trans[transIndex]['type'] === 'sale') {
                                            fieldValue = trans[transIndex]['terminal_external_id']
                                        }
                                        break;
                                    default:
                                        fieldValue = (trans[transIndex][export_struct[fieldIndex].value] === null)
                                            ? ''
                                            : trans[transIndex][export_struct[fieldIndex].value];
                                }
                                // customer fields
                                if (/^bcf_(.*)_value/.test(export_struct[fieldIndex].value) && trans[transIndex]['external_customer_info']) {
                                    if (trans[transIndex]['external_customer_info'] &&
                                        !!trans[transIndex]['external_customer_info'][export_struct[fieldIndex].value]) {
                                        fieldValue = trans[transIndex]['external_customer_info'][export_struct[fieldIndex].value];
                                    }
                                }

                                if (/^qf_(.*)_value/.test(export_struct[fieldIndex].value) && trans[transIndex]['corporate_customer_questionnaire']) {
                                    if (trans[transIndex]['corporate_customer_questionnaire'] &&
                                        !!trans[transIndex]['corporate_customer_questionnaire'][export_struct[fieldIndex].value]) {
                                        fieldValue = trans[transIndex]['corporate_customer_questionnaire'][export_struct[fieldIndex].value];
                                    }
                                }

                                if (/^taxes_(.*)/.test(export_struct[fieldIndex].value) && trans[transIndex]['calculated_taxes']) {

                                    if (trans[transIndex]['calculated_taxes']['base']) {
                                        trans[transIndex]['calculated_taxes']['base'].forEach(function (tax) {
                                            if (tax.value_id === export_struct[fieldIndex].value.replace('taxes_', '')) {
                                                fieldValue = tax.value;
                                            }
                                        })
                                    }

                                    if (trans[transIndex]['calculated_taxes']['sale']) {
                                        trans[transIndex]['calculated_taxes']['sale'].forEach(function (tax) {
                                            if (tax.value_id === export_struct[fieldIndex].value.replace('taxes_', '')) {
                                                fieldValue = tax.value;
                                            }
                                        })
                                    }
                                }

                                if (/^margins_(.*)/.test(export_struct[fieldIndex].value) && trans[transIndex]['calculated_margins']) {
                                    if (trans[transIndex]['calculated_margins']['terminal_additional_costs']) {
                                        trans[transIndex]['calculated_margins']['terminal_additional_costs'].forEach(function (margin) {
                                            if (margin.value_id === export_struct[fieldIndex].value.replace('margins_', '')) {
                                                fieldValue = margin.value;
                                            }
                                        })
                                    }
                                }

                                el[fieldName] = fieldValue || '';
                            }
                            export_data.push(el);
                        }
                    } else {
                        var emptyEl = {};
                        for (var fieldIndex in export_struct) {
                            var emptyFieldName = export_struct[fieldIndex].text;
                            if (emptyFieldName.trim() !== '') {
                                emptyEl[emptyFieldName] = '';
                                export_data.push(emptyEl);
                            }

                        }
                    }

                    $scope.$evalAsync(function ($scope) {
                        block_transactions_list.stop();
                        $scope.data.isFilePreparing = false;
                    });

                    // параметр utf8Bom нужен для экспорта без заголовков, иначе слетает кодировка
                    switch (format) {
                        case 'XLSX':
                            alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:' + $scope.data.exportHeaders + ', utf8Bom:true}) FROM ?',
                                [export_data]);
                            break;
                        case 'XLS':
                            alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:' + $scope.data.exportHeaders + ', utf8Bom:true}) FROM ?',
                                [export_data]);
                            break;
                        case 'CSV':
                            alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:' + $scope.data.exportHeaders +
                                ', separator:",", utf8Bom:true}) FROM ?', [export_data]);
                            break;
                    }
                });

            }

            var currentPage = 0,
                exportValues = [],
                partCount = 200;

            var exportParams = ExportService.generateExportParams(params, $scope.data.summary.total_rows_count, partCount);

            // Получение следующего массива записей
            function downloadNextPage(exportParams, currentPage) {
                return new Promise(function (resolve) {
                    ExportService.getTransactions(exportParams[currentPage]).then(function (resp) {
                        exportValues = [...exportValues, resp];
                        currentPage++;
                        ExportService.calculateExportValuesCount($scope, exportValues, $scope.data.summary.total_rows_count);
                        if (!isExportStopped
                            && !$scope.exportModal.isExportPaused
                            && exportParams[currentPage]) {
                            downloadNextPage(exportParams, currentPage).then(function (response) {
                                resolve(response);
                            });
                        } else {
                            resolve({currentPage: currentPage});
                        }
                    });
                });
            }

            function exportRequest() {
                downloadNextPage(exportParams, currentPage).then(function (response) {
                    currentPage = response.currentPage;
                    if (isExportStopped || !exportParams[currentPage]) {
                        $scope.modalExport.close();
                        handleExportResults();
                    }
                });
            }

            function handleExportResults() {
                var result = {};
                result.data = [];
                result.summary = {};
                exportValues.forEach(function (value) {
                    result.data = result.data.concat(value.data);
                    // result.summary = value.summary;
                });
                trans = result.data;
                generateFile();
            }

            exportRequest();
        };

        $scope.getTableHeaderClass = function (row) {
            return {
                'sorting_asc': $scope.params.transactions.sort_field == row.value && $scope.params.transactions.sort_direction == 'ASC',
                'sorting_desc': $scope.params.transactions.sort_field == row.value && $scope.params.transactions.sort_direction == 'DESC',
                'sorting': !row.not_sortable
            };
        };

        $scope.onSortOrderChange = function (row) {
            if (!!row.not_sortable) {
                return;
            }
            var field = row.value;
            if ($scope.params.transactions.sort_field === field)
                $scope.params.transactions.sort_direction = $scope.params.transactions.sort_direction == 'ASC' ? 'DESC' : 'ASC';

            $scope.params.transactions.sort_field = field;

            getTransactions();
        };

        $scope.pageChange = function () {
            getTransactions();
        };

        $scope.onCountChange = function (count) {
            $scope.params.transactions.page = 1;
            $scope.params.transactions.count = count;
            getTransactions();
        };

        $scope.onDisplaySettingsClick = function () {
            block_transactions_page.start();
            if ($scope.data.showTableDisplaySettings) {
                console.log('$scope.data.table_cols');
                console.log(angular.copy($scope.data.table_cols));
                CustomPreferencesService.saveCustomPreference(
                    customPreferencesKey,
                    {tableColumns: $scope.data.table_cols, exportHeaders: $scope.data.exportHeaders}
                ).then(function () {
                    block_transactions_page.stop();
                }, function () {
                    block_transactions_page.stop();
                });

                updateTransactionsSummary().then(function () {
                    $scope.data.showTableDisplaySettings = !$scope.data.showTableDisplaySettings;
                });
            } else {
                // переход в настройки колонок
                $scope.data.showTableDisplaySettings = !$scope.data.showTableDisplaySettings;
                block_transactions_page.stop();
            }

        };

        $scope.onDisplaySettingsSave = function () {
            $scope.onDisplaySettingsClick();
        };

        $scope.onColumnDisplayChange = function (index) {
            for (var i in $scope.data.table_cols[index].data)
                $scope.data.table_cols[index].data[i].visible = $scope.data.table_cols[index].visible;
        };

        $scope.onColumnDataDisplayChange = function (index) {
            $scope.data.table_cols.forEach(function (column) {
                return column.visible = column.data.some(function (data) {
                    return data.visible;
                });
            });
        };

        $scope.onColumnAdd = function (first) {
            if (first)
                $scope.data.table_cols.unshift({visible: true, data: []});
            else
                $scope.data.table_cols.push({visible: true, data: []});
        };

        $scope.onColumnsReset = function () {
            initTableColumns(true);
        };

        $scope.onColumnRemove = function (index) {
            $scope.data.table_cols.splice(index, 1);
        };

        $scope.onTransactionCancel = function (id) {
            var comment = document.getElementById('transactionCancelComment-' + id);

            var post_data = {
                transaction_id: id
            };
            if (comment.value)
                post_data.comment = comment.value;

            TransactionService.CancelTransaction(post_data, function (success, response) {
                if (success)
                    itemByIndex($scope.data.transactionsList, id).cancelled = 1;
            });
        };

        $scope.onTransactionFinalize = function (id) {
            var comment = document.getElementById('transactionFinalizeComment-' + id);

            var post_data = {
                transaction_id: id
            };
            if (comment.value)
                post_data.comment = comment.value;

            TransactionService.FinalizeTransaction(post_data, function (success, response) {
                if (success) {
                    _doShow(true);
                }
            });
        };

        $rootScope.$watch('LPR_LIST', function (newValue, oldValue) {
            $scope.data.filtersList = [];
            if (newValue && newValue.length > 0) {
                $scope.data.filtersList = angular.copy($rootScope.LPR_LIST);
                $scope.data.filtersList.unshift({title: $filter('translate')('All loyalties'), id: '0', active: 1});

                if ($rootScope.ENV.filters.transactions_list && !$scope.corporate_customer_id) {
                    try {
                        $scope.params.transactions = JSON.parse($rootScope.ENV.filters.transactions_list[ENV_KEY_PARAMS]);
                        $scope.params.transactions.transaction_type = null;
                        $scope.params.transactions.canceled = null;
                        $scope.params.transactions.page = 1;
                    } catch (e) {
                        $scope.params.transactions = angular.copy($scope.params.transactions_preset);
                    }
                }

                if ($rootScope.ENV.filters.global_filter && $rootScope.ENV.filters.global_filter.loyalty_id !== '0') {
                    $scope.data.currentFilter = $scope.data.filtersList.find(function (filterItem) {
                        if (filterItem.filter_list_type === 'loyalty') {
                            if (filterItem.id === $rootScope.ENV.filters.global_filter.loyalty_id) {
                                return true;
                            }
                        } else if (filterItem.filter_list_type === 'pos' || filterItem.filter_list_type === 'register') {
                            if (filterItem.loyalty_id === $rootScope.ENV.filters.global_filter.loyalty_id) {
                                return true;
                            }
                        }
                    });
                } else {
                    for (var i in $scope.data.filtersList)
                        if ($scope.data.filtersList[i].id === '0')
                            $scope.data.currentFilter = $scope.data.filtersList[i];
                }
            }
        });

        $scope.$watch('data.currentFilter', function (newValue, oldValue) {
            if (newValue) {
                _doShow(false);

                var l = $rootScope.ENV.filters.transactions_list;
                if (l)
                    l.filter = newValue;
                else
                    l = {filter: newValue};

                if (l.filter.filter_list_type === 'loyalty') {
                    $rootScope.ENV.filters.global_filter = {loyalty_id: l.filter.id};
                } else if (l.filter.filter_list_type === 'pos' || l.filter.filter_list_type === 'register') {
                    $rootScope.ENV.filters.global_filter = {loyalty_id: l.filter.loyalty_id};
                } else if (l.filter.id === '0') {
                    $rootScope.ENV.filters.global_filter = {loyalty_id: '0'};
                }

                $rootScope.ENV.filters.transactions_list = l;
                $rootScope.storeENV();
            }
        }, true);

        // $scope.$watchCollection(
        //     '[params.transactions.user_phone, params.transactions.comment, params.transactions.sc_terminal, params.transactions.sc_code]',
        //     function (newCollection, oldCollection) {
        //         if (newCollection && newCollection !== oldCollection) {
        //             // if (filterTimeout)
        //             //     $timeout.cancel(filterTimeout);
        //             //
        //             // filterTimeout = $timeout(function() {
        //             //     $scope.params.transactions.page = 1;
        //             //
        //             //     getTransactions();
        //             // }, 1000);
        //         }
        //     });

        var dateDiff = appConfig.dateDifferences && appConfig.dateDifferences.transactions ? appConfig.dateDifferences.transactions : 1;

        $scope.$watch('params.transactions.date_to', function (newValue, oldValue) {
            if (!!newValue && (moment(newValue).diff($scope.params.transactions.date_from, 'months', true)) > dateDiff)
                $scope.params.transactions.date_from = moment($scope.params.transactions.date_to).subtract(dateDiff, 'month').utc().toDate();
        });


        $scope.$watch('params.transactions.date_from', function (newValue, oldValue) {
            if (!!newValue && (moment($scope.params.transactions.date_to).diff(newValue, 'months', true)) > dateDiff)
                $scope.params.transactions.date_to = moment($scope.params.transactions.date_from).add(dateDiff, 'month').utc().toDate();
        });


        var unbindTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
            getSpecialAccounts();
            getBusinessStaffs();
        });

        $scope.$on('$destroy', unbindTranslateChangeSuccess);
    }
})();
